import { primaryLoader, smallLoader } from 'components/common/loaders';
import ContentLoader, { type IContentLoaderProps } from 'react-content-loader';

interface ICContentLoaderProps extends IContentLoaderProps {
  type?: 'primary' | 'small';
}

const typeLoader = {
  primary: primaryLoader,
  small: smallLoader,
};

export default function CContentLoader({ type = 'primary', ...props }: ICContentLoaderProps) {
  const loader = type;
  const { height, width, speed, viewBox, backgroundColor, foregroundColor, rects, circles } =
    typeLoader[loader];
  return (
    <div style={{ backgroundColor: 'white' }}>
      <ContentLoader
        height={height}
        width={width}
        speed={speed}
        viewBox={viewBox}
        backgroundColor={backgroundColor}
        foregroundColor={foregroundColor}
        {...props}
      >
        {rects.map(({ id, x, y, rx, ry, width: rectWidth, height: rectHeight }) => (
          <rect key={id} x={x} y={y} rx={rx} ry={ry} width={rectWidth} height={rectHeight} />
        ))}
        {circles.map(({ id, cx, cy, r }) => (
          <circle key={id} cx={cx} cy={cy} r={r} />
        ))}
      </ContentLoader>
    </div>
  );
}
